import React from 'react';
import LandingPage from './LandingPage';
import Header from './Header';
import Footer from './Footer';

function App() {
  return (
    <div>
      <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,700,800" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css?family=Source+Serif+Pro:300,400,700,800" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css?family=Abril+Fatface:300,400,700,800" rel="stylesheet" />
      <Header logged_in={false} />
      <LandingPage />
      <Footer />
    </div>
  );
}

export default App;
